module.exports = __webpack_public_path__ + "media/img/uploads/event-thumb-06-561a20554d9ae714436c5150b8e3dbee.jpg";